import React, { useState, useEffect, useRef } from 'react';
import {
  FaThLarge, FaCalendarCheck, FaClipboardList,
  FaUserGraduate, FaSignOutAlt, FaChevronDown, FaChevronUp
} from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import './TeacherMenu.css';

const TeacherMenu = ({ onMenuClick, isOpen, toggleMenu }) => {
  const [activeSection, setActiveSection] = useState('Dashboard');
  const [expandedMenus, setExpandedMenus] = useState({});
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const navigate = useNavigate();
  const menuRef = useRef(null);

  // Update isMobile on resize
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Menu item click handler
  const handleMenuItemClick = (section) => {
    if (section === 'Logout') {
      const confirmLogout = window.confirm('Are you sure you want to log out?');
      if (confirmLogout) {
        localStorage.clear();
        window.location.href = '/login'; // Hard redirect
      }
      return;
    }

    setActiveSection(section);
    onMenuClick(section);

    if (isMobile && toggleMenu) toggleMenu(); // close menu on mobile

    // Navigation with replace to prevent back to login
    switch (section) {
      case 'Attendance Report':
        navigate('/teacher/reports/attendance', { replace: true });
        break;
      case 'Assignment Report':
        navigate('/teacher/reports/assignment', { replace: true });
        break;
      case 'Results Report':
        navigate('/teacher/reports/results', { replace: true });
        break;
      case 'Dashboard':
        navigate('/teacher/dashboard', { replace: true });
        break;
      default:
        navigate(`/teacher/${section.toLowerCase().replace(/ /g, '-')}`, { replace: true });
    }
  };

  const toggleSubmenu = (menu) => {
    setExpandedMenus((prev) => ({ ...prev, [menu]: !prev[menu] }));
  };

  const handleToggleMenu = () => {
    if (isOpen) setExpandedMenus({});
    toggleMenu();
  };

  const menuItems = [
    { name: 'Dashboard', icon: <FaThLarge /> },
    { name: 'Student List', icon: <FaUserGraduate /> },
    { name: 'Attendance', icon: <FaCalendarCheck /> },
    { name: 'Assignments', icon: <FaClipboardList /> },
    {
      name: 'Reports',
      icon: <FaClipboardList />,
      children: [
        { name: 'Attendance Report', icon: <FaCalendarCheck /> },
        { name: 'Assignment Report', icon: <FaClipboardList /> },
        { name: 'Results Report', icon: <FaClipboardList /> }
      ]
    },
    { name: 'Logout', icon: <FaSignOutAlt /> }
  ];

  return (
    <div ref={menuRef} className={`teacher-sidebar ${isOpen ? 'open' : 'collapsed'}`}>
      <div className="teacher-menu-links">
        {menuItems.map(({ name, icon, children }) => (
          <div key={name}>
            <div
              className={`teacher-menu-item ${activeSection === name ? 'active' : ''}`}
              onClick={() => (children ? toggleSubmenu(name) : handleMenuItemClick(name))}
            >
              {isOpen && <span className="teacher-menu-icon">{icon}</span>}
              {isOpen && <span className="teacher-menu-text">{name}</span>}
              {children && isOpen && (
                <span className="dropdown-icon">
                  {expandedMenus[name] ? <FaChevronUp /> : <FaChevronDown />}
                </span>
              )}
            </div>

            {children && expandedMenus[name] && isOpen && (
              <div className="teacher-submenu">
                {children.map((child) => (
                  <div
                    key={child.name}
                    className={`teacher-submenu-item ${activeSection === child.name ? 'active' : ''}`}
                    onClick={() => handleMenuItemClick(child.name)}
                  >
                    {isOpen && <span className="teacher-menu-icon">{child.icon}</span>}
                    {isOpen && <span className="teacher-menu-text">{child.name}</span>}
                  </div>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default TeacherMenu;
